<template>
  <BreadCrumb PageTitle="Historique" />
  <TimeLineNote  />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import TimeLineNote from "@/components/Notes/Return/Client/TimeLineNote.vue";

import { useRoute } from "vue-router";
export default defineComponent({
  name: "TimeLineNotePage",
  components: {
    BreadCrumb,
    TimeLineNote,
  },

  setup: () => {
    const route = useRoute();
    let id = route.params.id; 
    if (Array.isArray(id)) {
      id = id[0] ?? "";
    }

    let refNote = route.params.refNote; 
    if (Array.isArray(refNote)) {
      refNote = refNote[0] ?? "";
    }


    return { id , refNote};
}
});
</script>